/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedResultInvoiceItemSummary,
  SortDirection,
} from '../models/index';
import {
    PagedResultInvoiceItemSummaryFromJSON,
    PagedResultInvoiceItemSummaryToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/index';

export interface GetInvoiceItemProjectionOfCurrentRetailerRequest {
    offset?: number;
    limit?: number;
    parentInvoiceId?: string;
    productNumber?: string;
    fulltextQuery?: string;
    sortByHeoItemId?: SortDirection;
    sortByInvoiceCreatedAt?: SortDirection;
    sortByInvoiceNumber?: SortDirection;
    sortByInvoiceTotal?: SortDirection;
    sortByCustomerOrderNumber?: SortDirection;
    sortByProductOriginCountry?: SortDirection;
    sortByProductTariffNumber?: SortDirection;
    sortByQuantity?: SortDirection;
    sortByPricePerUnit?: SortDirection;
    sortByDiscount?: SortDirection;
    sortByDiscountedPricePerUnit?: SortDirection;
    sortByTotal?: SortDirection;
    sortByCustomerItemReference?: SortDirection;
    sortByCustomerReference?: SortDirection;
    sortByProductNumber?: SortDirection;
}

/**
 * 
 */
export class InvoiceItemResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getInvoiceItemProjectionOfCurrentRetailer without sending the request
     */
    async getInvoiceItemProjectionOfCurrentRetailerRequestOpts(requestParameters: GetInvoiceItemProjectionOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['parentInvoiceId'] != null) {
            queryParameters['parentInvoiceId'] = requestParameters['parentInvoiceId'];
        }

        if (requestParameters['productNumber'] != null) {
            queryParameters['productNumber'] = requestParameters['productNumber'];
        }

        if (requestParameters['fulltextQuery'] != null) {
            queryParameters['fulltextQuery'] = requestParameters['fulltextQuery'];
        }

        if (requestParameters['sortByHeoItemId'] != null) {
            queryParameters['sortByHeoItemId'] = requestParameters['sortByHeoItemId'];
        }

        if (requestParameters['sortByInvoiceCreatedAt'] != null) {
            queryParameters['sortByInvoiceCreatedAt'] = requestParameters['sortByInvoiceCreatedAt'];
        }

        if (requestParameters['sortByInvoiceNumber'] != null) {
            queryParameters['sortByInvoiceNumber'] = requestParameters['sortByInvoiceNumber'];
        }

        if (requestParameters['sortByInvoiceTotal'] != null) {
            queryParameters['sortByInvoiceTotal'] = requestParameters['sortByInvoiceTotal'];
        }

        if (requestParameters['sortByCustomerOrderNumber'] != null) {
            queryParameters['sortByCustomerOrderNumber'] = requestParameters['sortByCustomerOrderNumber'];
        }

        if (requestParameters['sortByProductOriginCountry'] != null) {
            queryParameters['sortByProductOriginCountry'] = requestParameters['sortByProductOriginCountry'];
        }

        if (requestParameters['sortByProductTariffNumber'] != null) {
            queryParameters['sortByProductTariffNumber'] = requestParameters['sortByProductTariffNumber'];
        }

        if (requestParameters['sortByQuantity'] != null) {
            queryParameters['sortByQuantity'] = requestParameters['sortByQuantity'];
        }

        if (requestParameters['sortByPricePerUnit'] != null) {
            queryParameters['sortByPricePerUnit'] = requestParameters['sortByPricePerUnit'];
        }

        if (requestParameters['sortByDiscount'] != null) {
            queryParameters['sortByDiscount'] = requestParameters['sortByDiscount'];
        }

        if (requestParameters['sortByDiscountedPricePerUnit'] != null) {
            queryParameters['sortByDiscountedPricePerUnit'] = requestParameters['sortByDiscountedPricePerUnit'];
        }

        if (requestParameters['sortByTotal'] != null) {
            queryParameters['sortByTotal'] = requestParameters['sortByTotal'];
        }

        if (requestParameters['sortByCustomerItemReference'] != null) {
            queryParameters['sortByCustomerItemReference'] = requestParameters['sortByCustomerItemReference'];
        }

        if (requestParameters['sortByCustomerReference'] != null) {
            queryParameters['sortByCustomerReference'] = requestParameters['sortByCustomerReference'];
        }

        if (requestParameters['sortByProductNumber'] != null) {
            queryParameters['sortByProductNumber'] = requestParameters['sortByProductNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/invoice-item`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getInvoiceItemProjectionOfCurrentRetailerRaw(requestParameters: GetInvoiceItemProjectionOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedResultInvoiceItemSummary>> {
        const requestOptions = await this.getInvoiceItemProjectionOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedResultInvoiceItemSummaryFromJSON(jsonValue));
    }

    /**
     */
    async getInvoiceItemProjectionOfCurrentRetailer(requestParameters: GetInvoiceItemProjectionOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedResultInvoiceItemSummary> {
        const response = await this.getInvoiceItemProjectionOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
